export default "__VITE_ASSET__Dyjs5$41__"